export default __webpack_public_path__ + "static/blog-6461501ff8950e5ddc4710b27582d67d.png";